export default "__VITE_ASSET__9cb8b64d__"